export default "__VITE_ASSET__CJVhmD70__"